import axios from "axios";

function serializeError(error) {
    if (error instanceof Error) {
        const plain = {};
        Object.getOwnPropertyNames(error).forEach(key => {
            plain[key] = error[key];
        });
        plain.name = error.name;
        plain.message = error.message;
        plain.stack = error.stack;
        return plain;
    }
    return error;
}

// 모든 타입을 안전하게 stringify (순환 참조 포함)
function safeStringify(value, seen = new WeakSet()) {
    if (value === null) return 'null';
    if (typeof value === 'undefined') return 'undefined';
    if (typeof value === 'function') return '[Function]';
    if (typeof value === 'symbol') return value.toString();
    if (typeof value === 'bigint') return value.toString() + 'n';
    if (typeof value === 'boolean' || typeof value === 'number') return value.toString();
    if (typeof value === 'string') return value;

    if (seen.has(value)) return '[Circular]';
    seen.add(value);

    if (value instanceof Error) {
        return JSON.stringify(serializeError(value));
    }

    if (Array.isArray(value)) {
        return '[' + value.map(v => safeStringify(v, seen)).join(', ') + ']';
    }

    if (value instanceof Map) {
        const mapObj = {};
        for (let [k, v] of value.entries()) {
            mapObj[`MapKey:${String(k)}`] = safeStringify(v, seen);
        }
        return JSON.stringify(mapObj);
    }

    if (value instanceof Set) {
        return JSON.stringify({ Set: Array.from(value).map(v => safeStringify(v, seen)) });
    }

    if (typeof value === 'object') {
        const obj = {};
        for (let key in value) {
            try {
                obj[key] = safeStringify(value[key], seen);
            } catch (e) {
                obj[key] = '[Unserializable]';
            }
        }
        return JSON.stringify(obj);
    }

    return '[Unknown Type]';
}

// 서버 로그 전송 함수
export const serverLog = async (...args) => {
    try {
        const rawMessage = args.map(arg => safeStringify(arg)).join(' | ');
        // 문자열 깨짐 방지
        const encodedMessage = decodeURIComponent(encodeURIComponent(rawMessage));
        await axios.post('/log', { message: encodedMessage });
    } catch (error) {
        console.log('[serverLog 전송 실패]', error);
    }
};